import React from "react";
import CrossArrow from "../assets/images/svg/cross-arrow.svg";

const CostCalculator: React.FC = () => {
    return (
        <div className="get-cost-estimate" style={{ textAlign: "center", padding: "2rem 0" }}>
            <a href="https://widget.sprzatasia.pl/" target="_blank" rel="noreferrer" className="btn-quote" style={{ fontSize: "1.2rem", padding: "1rem 2.5rem" }}>
                Zamów sprzątanie
                <img src={CrossArrow} alt="cross-arrow" />
            </a>
        </div>
    );
};

export default CostCalculator;
